import { SET_PRESSURE_NOTIFICATION, SET_PRESSURE_RECORD } from './actionTypes';
export function setPressureRecord(value) {
    return {
        type: SET_PRESSURE_RECORD,
        value
    };
}
export function setPressureNotification(value) {
    return {
        type: SET_PRESSURE_NOTIFICATION,
        value
    };
}
